const DomainCrawlResultManagementColumn = [
  {
    title: 'No.',
    dataIndex: 'index',
    width: 50,
  },
  {
    title: 'Seed URL',
    dataIndex: 'seed_url',
    slot: 'seed_url',
    width: 250,
  },
  {
    title: 'Crawl Depth',
    dataIndex: 'depth',
    slot: 'depth',
    width: 100,
  },
  {
    title: 'Crawl Start',
    dataIndex: 'start',
    slot: 'start',
    width: 200,
  },
  {
    title: 'Crawl End',
    dataIndex: 'end',
    slot: 'end',
    width: 200,
  },
  {
    title: 'Crawl Status',
    dataIndex: 'status',
    slot: 'status',
    width: 200,
  },
  {
    title: '',
    dataIndex: '',
    width: 50,
    slot: 'operation',
  },
];

export { DomainCrawlResultManagementColumn };
